import React from 'react';
import { Card, Typography } from 'antd';
import { useTravelThemes } from 'api/travel-themes.api';
import type { DestinationTravelThemeSchema } from 'typings/destinations/DestinationTravelThemeSchema';
import { DestinationTravelThemeSelector } from './DestinationTravelThemeSelector';

const { Text } = Typography;

type DestinationTravelThemesCardProps = Readonly<{
    destinationId: number;
    travelThemes: DestinationTravelThemeSchema[];
    onUpdate: (themes: DestinationTravelThemeSchema[]) => void;
}>;

export function DestinationTravelThemesCard({
    destinationId,
    travelThemes,
    onUpdate,
}: DestinationTravelThemesCardProps) {
    const { themes: allThemes, isLoading: isLoadingThemes } = useTravelThemes();
    const hasTravelThemes = allThemes.length > 0;

    return (
        <Card
            title={<Text strong>Travel Themes</Text>}
            loading={isLoadingThemes}
        >
            {hasTravelThemes ? (
                <DestinationTravelThemeSelector
                    destinationId={destinationId}
                    allThemes={allThemes}
                    travelThemes={travelThemes}
                    onUpdate={onUpdate}
                />
            ) : (
                <Text type="secondary">
                    No travel themes available. Create some first in
                    Destinations &gt; Travel Themes.
                </Text>
            )}
        </Card>
    );
}
